module.exports = __webpack_public_path__ + "static/img/enterprise-logo.1a94c0cc.jpg";